const _floatHeaderOnScroll = (target, scrollTopPos) => {
  if (target) {
    if (document.documentElement.scrollTop < scrollTopPos && !target.classList.contains('is-visible')) {
      target.classList.add('is-visible')
    }

    if (document.documentElement.scrollTop === 0) {
      target.classList.remove('is-visible')
    }

    return document.documentElement.scrollTop

  } else {
    console.warn('Float Header On Scroll: No target given')
  }
}

const _topSpanOnScroll = (target, bottomTarget = false) => {
  if (target) {
    let startTriggered = window.scrollY >= target.offsetTop
    let stopTriggered = false

    if (bottomTarget) {
      stopTriggered = (window.scrollY + window.outerHeight) >= bottomTarget.offsetTop
    }

    if (startTriggered && !stopTriggered) {
      document.querySelector(target.dataset.target).classList.add('is-fixed')
    } else if (stopTriggered) {
      document.querySelector(target.dataset.target).classList.remove('is-fixed')
      document.querySelector(bottomTarget.dataset.target).classList.add('is-absolute')
    } else {
      document.querySelector(target.dataset.target).classList.remove('is-fixed')
      document.querySelector(bottomTarget.dataset.target).classList.remove('is-absolute')
    }
  } else {
    console.warn('Top Span On Scroll: No target given')
  }
}

const documentOnScroll = () => {
  const topSpanEl = document.querySelector('.js-top-span')
  const floatHeaderEl = document.querySelector('.js-float-header')
  const bottomSpanEl = document.querySelector('.js-bottom-span')

  let scrollTopPos = 0

  document.addEventListener('scroll', (ev) => {
    if (topSpanEl && window.outerWidth >= 1024) {
      _topSpanOnScroll(topSpanEl, bottomSpanEl)
    }
  
    if (floatHeaderEl) {
      scrollTopPos = _floatHeaderOnScroll(floatHeaderEl, scrollTopPos)
    }
  })
}

const initScroll = () => {
  document.addEventListener('scroll', () => documentOnScroll())
}

export { initScroll }